import dayjs from 'dayjs';
import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { NAME as name, CRUMB_LABEL_KEY, RozsahDate } from '../constants';
import { apiProvider } from '../api';
import { mutations } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		VyrobekvozOzn: [],
		VyrobekndOzn: [],
		SpTyp: [],
		StrednaklOzn: [],
		StrednakltypOzn: [],
		OjId: [],
		NoraPzn: [],
		SkladOzn: [],
		PracovnikOzn: [] as DropdownItem[],
		Vynosy: [] as DropdownItem[],
	},
	filter: {
		DetailTisk: false,
		DatOd: null as Date | null,
		DatDo: null as Date | null,
		RozsahDate: RozsahDate.casLibObdobi,
		ProvozovnaId: null as number | null,
		VyrobekvozOzn: null as string | null,
		SpTyp: null as number | null,
		SpKateg: null as string | null,
		SpNr: null as string | null,
		StrednaklOzn: null as number | null,
		StrednakltypOzn: null as number | null,
		OjId: null as number | null,
		NoraPzn: null as number | null,
		NdNr: null as string | null,
		NdNrPodret: true,
		NorazadpcComp: true,
		MarketKody: [] as string[],
		SkladOzn: null as number | null,
		PracovnikOzn: null as string | null,
		PracovnikId: null as number | null,
		VyrobekndOzn: null as number | null,
		Vynosy: 0,
	},
	tableSetting: {},
	localState: {
		accessFlags: 0,
		RozsahDateList: [] as { Text: string, Value: RozsahDate }[],
		PracovnikOsobniCis: null as string | null,
		PracovnikText: null as string | null,
	},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		setRozsahDate(state, rozsah: RozsahDate) {
			state.filter.RozsahDate = rozsah;
			const start = dayjs().startOf('day');
			const kvartal = (start.month() - 1) / 3;

			switch (rozsah) {
				case RozsahDate.casDnes:
					state.filter.DatOd =	start.toDate();
					state.filter.DatDo = dayjs().toDate();
					break;
				case RozsahDate.casVcera:
					state.filter.DatOd =	start.add(-1, 'day').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).endOf('day').toDate();
					break;
				case RozsahDate.casTentoMesic:
					state.filter.DatOd =	start.startOf('month').toDate();
					state.filter.DatDo = dayjs().toDate();
					break;
				case RozsahDate.casMinulyMesic:
					state.filter.DatOd =	start.startOf('month').add(-1, 'month').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).endOf('month').toDate();
					break;
				case RozsahDate.casTentoRok:
					state.filter.DatOd =	start.startOf('year').toDate();
					state.filter.DatDo = dayjs().toDate();
					break;
				case RozsahDate.casMinulyRok:
					state.filter.DatOd =	start.startOf('year').add(-1, 'year').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).endOf('year').toDate();
					break;
				case RozsahDate.casMinulyKvart:
					state.filter.DatOd =	start.startOf('year').add(((kvartal - 1) * 3), 'month').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).add(2, 'month').endOf('month').endOf('day')
						.toDate();
					break;
				default:
			}
		},
		[mutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.filter.PracovnikId = data.value;
			state.localState.PracovnikOsobniCis = data.osobniCis;
			state.localState.PracovnikText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => { },
	},
});
